var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`border-radius:12px;background-color:#F0F4F9;background-image:url('${_vm.url}');
              background-repeat:no-repeat;background-size:cover;height:${_vm.height}px;width:${_vm.width}px`)})
}
var staticRenderFns = []

export { render, staticRenderFns }